import { boolean, object, string } from 'yup'

export const reopenEncounterSchema = object({
  reason: string().trim().required('Reason is required')
})

export const notesSchema = object({
  content: string().required('Content is required')
})

export const procedureNotesSchema = object({
  note: string().required('Note is required')
})

export const cancelledNotesSchema = object({
  note: string()
})

export const procedureOrderSchema = object({
  notes: string().optional(),
  procedure: string().required('Procedure is required')
})

export const consentApprovalSchema = (isIntakeConsent = false) =>
  object({
    is_signed: boolean()
      .oneOf([true], 'You must first agree to the terms and conditions provided')
      .required('You must first agree to the terms and conditions provided'),
    signature: string().required(`Please save signature`),
    signed_by: string().required(`Signee's full name is required`),
    signee_relationship: string(),
    attending_signature: isIntakeConsent
      ? string().notRequired()
      : string().required(`Physician's signature is required`)
  })

export const scheduleProcedureSchema = object({
  attending_doctor_id: string().required('Primary doctor is required'),
  note: string().optional(),
  scheduled_date: string().required('Scheduled date is required'),
  scheduled_time: string().required('Scheduled time is required')
})
export const encounterSchema = object({
  date_of_service: string().required('Date of service is required'),
  encounter_provider: string().required('Encounter provider is required'),
  encounter_type: string().required('Encounter type is required'),
  primary_provider: string(),
  purpose: string().required('Reason for visit is required')
})
